/**
 * JobDetailsPage - Job details page
 * Refactored to use extracted hook and components
 */
import React from 'react';
import { useParams } from 'react-router-dom';
import { MainLayout } from '../components/MainLayout';
import { Header } from '../components/Header';
import TabsContagem from '../components/contagem/TabsContagem';
import { useConfirm } from '../hooks/useConfirm';
import { useJobDetails } from '../hooks/useJobDetails';
import {
  JobInfoCard,
  JobHeader,
  JobLoadingState,
} from '../components/job-details';

export default function JobDetailsPage() {
  const { confirm, ConfirmDialog } = useConfirm();
  const { id } = useParams<{ id: string }>();

  const {
    job,
    loading,
    hasPrevious,
    hasNext,
    handlePrevious,
    handleNext,
    handleGoBack,
  } = useJobDetails({ id, confirm });

  // Handle loading and not found states
  const loadingState = <JobLoadingState loading={loading} job={job} />;
  if (loading || !job) {
    return loadingState;
  }

  return (
    <>
      <ConfirmDialog />
      <MainLayout className="dark:bg-gray-900">
        <Header title="Detalhes da Contagem" subtitle={job?.titulo || ''} />
        <main className="p-6">
          <div className="max-w-7xl mx-auto">
            {/* Page Header */}
            <JobHeader
              jobId={id || ''}
              hasPrevious={hasPrevious}
              hasNext={hasNext}
              onPrevious={handlePrevious}
              onNext={handleNext}
              onGoBack={handleGoBack}
            />

            {/* Job Info Card */}
            <JobInfoCard job={job} />

            {/* Epic 18: Complete Counting System */}
            <TabsContagem
              jobId={parseInt(id || '0')}
              jobTitulo={job.titulo || ''}
              hospitalNome={job.hospital_nome || 'Hospital'}
            />
          </div>
        </main>
      </MainLayout>
    </>
  );
}
